import React, { Component } from 'react';

import './Card.css';
import HTMLLogo from '../images/html.png';
import CSSLogo from '../images/css.png';
import JavaScriptLogo from '../images/javascript.png';
import ReactLogo from '../images/react.png';
import netlifyLogo from '../images/netlify.png';
import jestLogo from '../images/jest.png';

class CardC extends Component {
    render() {
        return (
            <div className="Card"> {/* 3rd card start */}
                <h2>Habit Tracker</h2>
                <h4>HTML, CSS, JavaScript, TDD: Jest/Enzyme, Nodemon, React, Postgres SQL, ChartJs, Docker, Netlify</h4>
                <p>Keep track of your habits here on a daily or weekly basis. Keep up your streaks and reach your goals!</p>
                <div className="card-lang">
                <img src={HTMLLogo} alt="HTM5" /> &nbsp; 
                <img src={CSSLogo} alt="CSS3" /> &nbsp; 
                <img src={JavaScriptLogo} alt="JavaScript" /> &nbsp; 
                <img src={ReactLogo} alt="React" /> &nbsp; 
                <img src={netlifyLogo} alt="Netlify" /> 
                <img src={jestLogo} alt="Jest" /> &nbsp;

                </div><br />
                <div className="card-nav">
                    <div className="card-nav-left">
                        <a href="https://github.com/FopeA6/iHabit-project" target="_blank" rel="noopener noreferrer">View Source Code</a>
                    </div>
                    <div className="card-nav-right">
                        <a href="https://ihabit.netlify.app" target="_blank" rel="noopener noreferrer">View Project</a>
                    </div>
                </div>
            </div>
        );
    }
}

export default CardC
